import { BlackjackDealer, BlackjackListener } from 'game-logic';
import { RemoteRoundResultSubmitter } from '../../common/phaser/model/remote-round-result-submitter';
import { RemoteRoundParams, RoundParams } from '../../common/phaser/model/round-params';
import { RemoteDealer } from './remote-dealer';

export class BlackjackRemoteRoundParams extends RemoteRoundParams {
  constructor(
    readonly dealer: BlackjackDealer,
    remoteRoundResultSubmitter: RemoteRoundResultSubmitter,
    readonly logicVersion: number,
  ) {
    super(remoteRoundResultSubmitter);
    this.dealer = dealer;
  }

  public static create(
    gameListener: BlackjackListener,
    logicVersion: number,
  ): BlackjackRemoteRoundParams {
    return new BlackjackRemoteRoundParams(
      new RemoteDealer(gameListener),
      new RemoteRoundResultSubmitter(gameListener),
      logicVersion,
    );
  }

  public static isRound(roundParams: RoundParams): roundParams is BlackjackRemoteRoundParams {
    return roundParams instanceof BlackjackRemoteRoundParams;
  }
}
